import React from "react";

const calendarIcon = require("../../assets/calendar.png");

const formatDateKey = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const formatDisplayDate = (dateKey) => {
  if (!dateKey) {
    return "";
  }
  const [year, month, day] = String(dateKey).split("-");
  if (!year || !month || !day) {
    return dateKey;
  }
  return `${month}-${day}-${year}`;
};

const parseDateKey = (dateKey) => {
  const [year, month, day] = String(dateKey || "")
    .split("-")
    .map(Number);
  if (!year || !month || !day) {
    return null;
  }
  return new Date(year, month - 1, day);
};

const FamilyDateNavigator = ({ selectedDateKey, onChange, maxDateKey, onOpenCalendar }) => {
  const selectedDate = parseDateKey(selectedDateKey) || new Date();
  const maxDate = parseDateKey(maxDateKey);
  const isToday = selectedDateKey === maxDateKey;
  const canGoNext = !maxDate || selectedDate < maxDate;

  const goToPreviousDay = () => {
    const next = new Date(selectedDate);
    next.setDate(next.getDate() - 1);
    onChange?.(formatDateKey(next));
  };

  const goToNextDay = () => {
    if (!canGoNext) {
      return;
    }
    const next = new Date(selectedDate);
    next.setDate(next.getDate() + 1);
    onChange?.(formatDateKey(next));
  };

  return (
    <div className="family-date-navigator">
      <div className="family-date-box">
        <button type="button" className="family-date-nav-btn" onClick={goToPreviousDay} aria-label="Previous day">
          ❮
        </button>

        <button type="button" className="family-date-calendar-btn" onClick={onOpenCalendar} aria-label="Open calendar">
          <img src={calendarIcon} alt="" className="family-date-calendar-icon" />
        </button>

        <span className="family-date-today-label">{isToday ? "Today" : formatDisplayDate(selectedDateKey)}</span>

        <button type="button" className={`family-date-nav-btn${!canGoNext ? " is-disabled" : ""}`} onClick={goToNextDay} disabled={!canGoNext} aria-label="Next day">
          ❯
        </button>
      </div>
    </div>
  );
};

export default FamilyDateNavigator;
